/**
 * TimelineControls Component
 *
 * Renders zoom control buttons (zoom in, zoom out, reset).
 * Uses Ant Design icons for consistency with the rest of the app.
 */

import { Button, Space, Tooltip } from 'antd'
import {
  ZoomInOutlined,
  ZoomOutOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import type { TimelineControlsProps } from '../types'

/**
 * TimelineControls Component
 */
export function TimelineControls({
  onZoomIn,
  onZoomOut,
  onReset,
  canZoomIn,
  canZoomOut,
}: TimelineControlsProps) {
  return (
    <div className="timeline-controls">
      <Space size={4}>
        <Tooltip title="Zoom out (-)" mouseLeaveDelay={0}>
          <Button
            type="text"
            size="small"
            icon={<ZoomOutOutlined />}
            onClick={onZoomOut}
            disabled={!canZoomOut}
            aria-label="Zoom out"
          />
        </Tooltip>

        <Tooltip title="Zoom in (+)" mouseLeaveDelay={0}>
          <Button
            type="text"
            size="small"
            icon={<ZoomInOutlined />}
            onClick={onZoomIn}
            disabled={!canZoomIn}
            aria-label="Zoom in"
          />
        </Tooltip>

        <Tooltip title="Reset view (Home)" mouseLeaveDelay={0}>
          <Button
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={onReset}
            aria-label="Reset view"
          />
        </Tooltip>
      </Space>
    </div>
  )
}

export default TimelineControls
